import { render, staticRenderFns } from "./ChildCompanyRow.vue?vue&type=template&id=006095d4"
import script from "./ChildCompanyRow.vue?vue&type=script&lang=js"
export * from "./ChildCompanyRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports